import { useReducedMotion } from 'framer-motion';
import { useCallback } from 'react';

interface UseContentScroll {
  scrollRef: (node: HTMLDivElement) => void;
}

const useContentScroll = (): UseContentScroll => {
  const prefersReducedMotion = useReducedMotion();

  const scrollRef = useCallback(
    (node: HTMLDivElement | undefined) => {
      if (!node) return;
      const resizeObserver = new ResizeObserver(() => {
        node.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      });
      resizeObserver.observe(node);
    },
    [prefersReducedMotion],
  );

  return { scrollRef };
};

export default useContentScroll;
